// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class PageHeader extends React.Component {
	constructor( props ) {
		super( props )

		let slidesCount = 0

		if ( props.slidesCount ) {
			slidesCount = props.slidesCount
		}

		this.state = {
			prevImage: null,
			imageLoaded: false,
			slidesCount: slidesCount,
			activeSlide: 1,
			slidesWidth: null
		}
	}

	componentDidMount() {
		const { slidesCount } = this.props

		if ( slidesCount ) {
			this.setupSlider()
		}
	}

	componentWillUnmount() {
		clearInterval( this.interval )
	}

	componentWillReceiveProps( nextProps ) {
		const { page, overrideImage } = this.props
		const imageData = overrideImage ? overrideImage : page.featured_image
		const nextImageData = nextProps.overrideImage ? nextProps.overrideImage : nextProps.page.featured_image

		if ( ! imageData || ! imageData.url ) {
			return
		}

		if ( ! nextImageData || imageData.url != nextImageData.url ) {
			this.setState( {
				prevImage: imageData,
				imageLoaded: false
			} )

			setTimeout( () => {
				this.setState( {
					prevImage: null
				} )
			}, 1100 )
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		const { slidesCount } = this.props

		if ( ! slidesCount && prevProps.slidesCount ) {
			clearInterval( this.interval )
		}

		if ( slidesCount && ! prevProps.slidesCount || slidesCount != prevProps.slidesCount ) {
			clearInterval( this.interval )

			this.setupSlider()
		}
	}

	setupSlider = () => {
		this.interval = setInterval( this.timer, 3000 )

		setTimeout( () => {
			const slides = document.querySelectorAll( '.js-words span' )
			let maxWidth = 0

			Array.from( slides ).forEach( ( slide, i ) => {
				if ( slide.offsetWidth > maxWidth ) {
					maxWidth = slide.offsetWidth
				}
			} )

			this.setState( {
				width: maxWidth
			} )

			const el = document.querySelector( '.js-words' )

			if ( el ) {
				el.setAttribute( 'style', `width: ${maxWidth}px` )
			}

			this.timer()
		}, 500 )
	}

	timer = () => {
		const { slidesCount, activeSlide } = this.state
		const activeSlideNew = activeSlide == slidesCount ? 1 : activeSlide + 1

		this.setState({
			activeSlide: activeSlideNew
		})

		const elements = document.querySelectorAll( '.js-words span' )

		Array.from( elements ).forEach( ( element, i ) => {
			if ( i == ( activeSlide - 1 ) ) {
				element.classList.add( 'is-active' )
			} else {
				element.classList.remove( 'is-active' )
			}
		})
	}

	handleImageLoaded = () => {
		this.setState( {
			imageLoaded: true
		} )
	}

	renderLoading() {
		return (
			<div className="page-header page-header-is-loading">
				<div className="-inner">
					<div className="-image"></div>
				</div>
			</div>
		)
	}

	renderImage( imageData, isPrevious = false ) {
		const { imageLoaded } = this.state
		let wrapClass = imageLoaded ? '-image is-loaded' : '-image'

		if ( isPrevious ) {
			wrapClass = '-image is-loaded is-previous'
		}

		if ( ! imageData ) {
			return (
				<div className={ wrapClass }>
					<img
						className="-full"
						src={ siteData.site_featured_image_url }
						alt=""
						onLoad={ this.handleImageLoaded }
					/>
				</div>
			)
		}

		const wrapStyle = {
			// paddingBottom: 100 / page.featured_image.aspect_ratio + '%'
		}

		let imageMarkup, prevImageMarkup
		const srcset = imageData.srcset ? imageData.srcset : undefined

		// Calculate CSS percentages:
		let imagePosition = null

		if ( imageData.focal_point ) {
			const percentageX = ( imageData.focal_point.x / imageData.width ) * 100
			const percentageY = ( imageData.focal_point.y / imageData.height ) * 100
			imagePosition = percentageX.toFixed( 0 ) + '% ' + percentageY.toFixed( 0 ) + '%'
		} else if ( imageData.position ) {
			imagePosition = imageData.position
		}

		const imageStyle = {
			objectPosition: imagePosition
		}

		imageMarkup = (
			<div className={ wrapClass } style={ wrapStyle } key={ imageData.id }>
				<img
					className="-thumb"
					src={ imageData.thumb }
					alt={ imageData.alt }
					style={ imageStyle }
				/>

				<img
					className="-full"
					alt={ imageData.alt }
					src={ imageData.url }
					srcSet={ srcset }
					sizes="100vw"
					onLoad={ this.handleImageLoaded }
					style={ imageStyle }
				/>
			</div>
		)

		return imageMarkup
	}

	renderContent() {
		const { page, overrideImage, overrideText } = this.props
		const { prevImage } = this.state

		if ( ! page ) {
			return null
		}

		const imageData = overrideImage ? overrideImage : page.featured_image
		let titleText = page ? page.title.rendered : ''

		const title = (
			<h1 dangerouslySetInnerHTML={ { __html: titleText } }></h1>
		)

		const text = overrideText ? overrideText : (
			<div className="-title" key={ `${page.id}-title` }>
				{ title }
			</div>
		)

		const intro = page.intro.rendered ? (
			<div className="-intro" key={ `${page.id}-intro` } dangerouslySetInnerHTML={ { __html: page.intro.rendered } } />
		) : ''

		return (
			<div className="page-header">
				<div className="-inner">
					<div className="-text">
						<div className="-inner">
							{ text }
							{ intro }
						</div>
					</div>

					<div className="-image-wrap">
						{ prevImage && this.renderImage( prevImage, true ) }

						{ this.renderImage( imageData ) }
					</div>
				</div>
			</div>
		)
	}

	render() {
		return this.renderContent()
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( PageHeader )



// WEBPACK FOOTER //
// ./components/PageHeader/PageHeader.jsx